module.exports = __webpack_public_path__ + "assets/img/chevron.b93bffb4.svg";